module.exports = __webpack_public_path__ + "img/301.dfcc3771.png";